<template>
  <div></div>
</template>
<script>
export default {
  mounted() {
    this.$mpTrack('Error page mounted')
    throw new Error('testing sentry')
  }
}
</script>
<style lang="scss" scoped></style>
